(function(){
  'use strict';

  const POPULAR_CATEGORIES = [
    { label: 'Stühle',   url: '/collections/stuhle' },
    { label: 'Sofas',    url: '/collections/sofas' },
    { label: 'Sessel',   url: '/collections/sessel' },
    { label: 'Tische',   url: '/collections/tische' },
    { label: 'Hocker',   url: '/collections/hocker' },
    { label: 'Pflege',   url: '/collections/pflege' }
  ];

  const POPULAR_QUERIES = [
    'Filzgleiter', 'Rollen', 'Lederpflege',
    'Jason Gleiter', 'Schraube', 'Seifenflocken'
  ];

  function escapeHtml(s){
    return String(s).replace(/[&<>"']/g, c => ({
      '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
    }[c]));
  }

  function formatMoney(cents){
    if(cents == null) return '';
    const n = (cents/100).toFixed(2).replace('.', ',');
    return n + ' €';
  }

  function buildDropdown(){
    const dd = document.createElement('div');
    dd.className = 'wk-search-dd';
    dd.setAttribute('hidden', '');
    dd.innerHTML = `
      <div class="wk-search-dd__inner">
        <div class="wk-search-dd__zero">
          <div class="wk-search-dd__group">
            <div class="wk-search-dd__title">Beliebte Kategorien</div>
            <div class="wk-search-dd__chips">
              ${POPULAR_CATEGORIES.map(c =>
                `<a class="wk-search-dd__chip" href="${escapeHtml(c.url)}">${escapeHtml(c.label)}</a>`
              ).join('')}
            </div>
          </div>
          <div class="wk-search-dd__group">
            <div class="wk-search-dd__title">Häufig gesucht</div>
            <div class="wk-search-dd__queries">
              ${POPULAR_QUERIES.map(q =>
                `<a class="wk-search-dd__query" href="/search?q=${encodeURIComponent(q)}" data-q="${escapeHtml(q)}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/>
                  </svg>
                  <span>${escapeHtml(q)}</span>
                </a>`
              ).join('')}
            </div>
          </div>
        </div>
        <div class="wk-search-dd__results" hidden></div>
      </div>
    `;
    return dd;
  }

  let activeAbort = null;

  async function fetchResults(q){
    if(activeAbort) activeAbort.abort();
    activeAbort = new AbortController();
    const url = `/search/suggest.json?q=${encodeURIComponent(q)}` +
                `&resources[type]=product,collection,query` +
                `&resources[limit]=6&resources[options][unavailable_products]=last`;
    try {
      const r = await fetch(url, { signal: activeAbort.signal });
      if(!r.ok) return null;
      const j = await r.json();
      return j.resources && j.resources.results;
    } catch(e){
      if(e.name === 'AbortError') return null;
      console.warn('search suggest failed', e);
      return null;
    }
  }

  function renderResults(box, q, res){
    if(!res){
      box.innerHTML = `<div class="wk-search-dd__empty">Suche läuft…</div>`;
      return;
    }
    const products    = res.products    || [];
    const collections = res.collections || [];
    const queries     = res.queries     || [];

    if(!products.length && !collections.length && !queries.length){
      box.innerHTML = `
        <div class="wk-search-dd__empty">
          Keine Treffer für „${escapeHtml(q)}".
          <a href="/search?q=${encodeURIComponent(q)}">Trotzdem alle Ergebnisse zeigen →</a>
        </div>`;
      return;
    }

    let html = '';

    if(queries.length){
      html += `<div class="wk-search-dd__group">
        <div class="wk-search-dd__title">Vorschläge</div>
        <div class="wk-search-dd__queries">
          ${queries.slice(0,4).map(qq =>
            `<a class="wk-search-dd__query" href="/search?q=${encodeURIComponent(qq.text)}">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="11" cy="11" r="7"/><path d="m21 21-4.35-4.35"/>
              </svg>
              <span>${qq.styled_text || escapeHtml(qq.text)}</span>
            </a>`
          ).join('')}
        </div>
      </div>`;
    }

    if(collections.length){
      html += `<div class="wk-search-dd__group">
        <div class="wk-search-dd__title">Kategorien</div>
        <div class="wk-search-dd__chips">
          ${collections.slice(0,6).map(c =>
            `<a class="wk-search-dd__chip" href="${escapeHtml(c.url)}">${escapeHtml(c.title)}</a>`
          ).join('')}
        </div>
      </div>`;
    }

    if(products.length){
      html += `<div class="wk-search-dd__group">
        <div class="wk-search-dd__title">Produkte</div>
        <div class="wk-search-dd__products">
          ${products.map(p => {
            const img = p.featured_image
              ? `<img src="${escapeHtml(p.featured_image.url || p.image || '')}" alt="" loading="lazy">`
              : `<div class="wk-search-dd__noimg"></div>`;
            return `<a class="wk-search-dd__product" href="${escapeHtml(p.url)}">
              <div class="wk-search-dd__pimg">${img}</div>
              <div class="wk-search-dd__pinfo">
                <div class="wk-search-dd__ptitle">${escapeHtml(p.title)}</div>
              </div>
            </a>`;
          }).join('')}
        </div>
      </div>`;
    }

    html += `<a class="wk-search-dd__all" href="/search?q=${encodeURIComponent(q)}">
      Alle Ergebnisse für „${escapeHtml(q)}" anzeigen →
    </a>`;

    box.innerHTML = html;
  }

  function debounce(fn, ms){
    let t;
    return function(){
      const args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(() => fn.apply(ctx, args), ms);
    };
  }

  function wireSearch(){
    const form = document.querySelector('.wk-search-form');
    if(!form || form.dataset.wkWired) return;
    form.dataset.wkWired = '1';
    const input = form.querySelector('input[type="search"]');
    if(!input) return;

    const dd = buildDropdown();
    form.parentNode.appendChild(dd);
    const zero    = dd.querySelector('.wk-search-dd__zero');
    const results = dd.querySelector('.wk-search-dd__results');

    function open(){ dd.removeAttribute('hidden'); document.body.classList.add('wk-search-open'); }
    function close(){ dd.setAttribute('hidden',''); document.body.classList.remove('wk-search-open'); }

    function showZero(){ zero.hidden = false; results.hidden = true; }
    function showResults(){ zero.hidden = true; results.hidden = false; }

    const doSearch = debounce(async (q) => {
      results.innerHTML = `<div class="wk-search-dd__loading">Suche läuft…</div>`;
      showResults();
      const res = await fetchResults(q);
      if(input.value.trim() === q){
        renderResults(results, q, res);
      }
    }, 180);

    input.addEventListener('focus', () => {
      open();
      const q = input.value.trim();
      if(!q) showZero();
      else { showResults(); doSearch(q); }
    });

    input.addEventListener('input', () => {
      const q = input.value.trim();
      open();
      if(!q){ showZero(); return; }
      doSearch(q);
    });

    document.addEventListener('click', (e) => {
      if(!form.contains(e.target) && !dd.contains(e.target)) close();
    });

    document.addEventListener('keydown', (e) => {
      if(e.key === 'Escape'){ close(); input.blur(); }
    });
  }

  function go(){
    wireSearch();
    const obs = new MutationObserver(() => wireSearch());
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
